import { ApiPostRequest } from './api-post-request';
import { ApiParameters } from './api-parameters';
import { ShareType } from '../../interfaces/share-type';
import { Order } from '../../interfaces/order';
import { LotteryClass } from '../../interfaces/lottery-class';

export class ShareTypeAddReservationRequest extends ApiPostRequest
{
    public constructor(order: Order, shareType: ShareType, lotteryClass: LotteryClass, count: number, webapiBasepath: string)
    {
        const parameters = new ApiParameters()
            .addQueryParameter('orderid', order.Id)
            .addQueryParameter('lotteryclassid', lotteryClass.Id)
            .addQueryParameter('sharetypeid', shareType.Id)
            .addQueryParameter('count', count);

        super('sharetypereservation', parameters, null, null, webapiBasepath);
    }
}
